import React from "react";
import { Field } from "react-final-form";

export const CheckboxField = ( props ) => {
    const { fieldId, fieldLabel, fieldValue } = props;
    const radioId = fieldId.split( " " ).join( "" )
    return <div className="radio">
        <label htmlFor={ radioId + "_" + fieldValue }>
            <Field
                id={ radioId + "_" + fieldValue }
                component="input"
                type="checkbox"
                name={ fieldId }
                value={ fieldValue }
            />{ ' ' }
            { fieldLabel }
        </label>
    </div>
}